<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <ion-header class="transparent">
            <app-header class="dark-mode"
                        [backRoute]="['/tasks']"
                        [middleIcon]="userService.companyLogo !== 'assets/icon/journey-logo.svg'"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="true" [@enter]>
            </app-header>
        </ion-header>
        <div class="bg bg-inner-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform === 'mobile'}" [@enter]></div>
        <div class="box" [@enter]>
            <div class="title">
                <div>{{'__REVIEW_REPORT_TITLE__' | translate }}</div>
            </div>
            <div class="subtitle primary-color">{{'__REVIEW_REPORT_SUBTITLE__' | translate }}s</div>
        </div>
        <div class="shadow-container" *ngIf="feedback === null">
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
        </div>

        <form (ngSubmit)="onSubmit()" #form="ngForm" class="shadow-container" *ngIf="feedback !== null">
            <img (click)="goBack()" src="assets/img/close.svg" alt=""
                 style="position: absolute; top: 0.5rem; right: 0.5rem; height: 2.5rem; width: 2.5rem;">
            <div class="padding-left-box">
                <div class="shadow-header font-header">
                    <span *ngIf="level === 'manager'">{{feedback.report_delegate.full_name}} <span style="font-weight: normal;">- {{'__REVIEW_REPORT_FEEDBACK_FORM_TITLE__' | translate}}</span></span>
                    <div style="border-bottom: 2px solid #8dc63f; width: 70%;"></div>
                </div>
                <div *ngIf="level === 'manager'" class="font-smaller" [innerHTML]="'__REVIEW_REPORT_FEEDBACK_FORM_CONTENT__' | translate"></div>
            </div>
            <div class="feedback-element">
                <div class="dropdown-content">
                    <app-questionnaire-input
                        *ngFor="let answer of feedback.answers.value"
                        [form]="'review-feedback'"
                        [title]="answer.question.title"
                        [hint]="answer.question.hint"
                        [(answer)]="answer.answer.value"
                        [disabled]="answer.answer.options.read_only"
                        class="line-top"
                    ></app-questionnaire-input>
                </div>
                <div class="form-actions-wrap">
                    <img src="assets/img/{{ feedback.status.value ? 'tick-large-icon-active.svg' : 'tick-large-icon.svg' }}"
                         alt="Goal Status Change"
                         (click)="onStatusChange(feedback.status.value)">
                </div>
            </div>
        </form>
    </div>
</ion-content>
<ion-footer *ngIf="!isSaved" class="swiper-no-swiping">
    <app-footer (saveEvent)="onSubmit()" [backButton]="false" [saveButton]="true" [isSaving]="isSaving"></app-footer>
</ion-footer>
